import React, {useEffect, useState, useReducer} from 'react'
import { useTranslation } from 'react-i18next'
import Helmet from 'react-helmet'
import Layout from '../components/Layout'
import PropTypes from 'prop-types'
import LoadingSpinner from '../components/Shared/LoadingSpinner'
import { initStateArray, arrayReducer } from '../reducers/default'
import { useSelector, useDispatch } from 'react-redux'
import { fetchMessages, markMessagesAsRead, notificationUpdate, checkNewMessages } from '../api/messages'
import MessageDetalis from '../components/Messages/MessageDetalis'
import MessagesList from '../components/Messages/MessagesList'
import { isFeatureFlagOn, SHOW_NOTIFICATION } from '../utils/flag-feature'
import { Redirect } from 'react-router-dom'


/**
 * Messages page.
 * It displays table with messages.
 * @Tags( page, layout, logged-users, messages, api )
 * @SuggestedTags( dashboard )
 * @Endpoints( /messages )
 * @ApiLogic( ../api/messages )
 * @Routes( /messages )
 */
const Messages = () => {
  const { t } = useTranslation() 
  const pageInit = { currentPage: 1, loading: false, currentMessageID: null, showDetalisMessage: false }
  const [page, setPage] = useState( {...pageInit} )
  const [messages, dispatch] = useReducer( arrayReducer, initStateArray )
  const globalDispatch = useDispatch()
  const newNotification = useSelector(store => store.user.newNotifications )
  const features = useSelector( store => store.user.features )

  useEffect( () => {
    fetchMessages(dispatch, {page: 1})
  }, [] )

  if ( !isFeatureFlagOn(features, SHOW_NOTIFICATION) ) {
    return ( <Redirect to="/" /> )
  }
 
  const handleShowMessageDetails = (message) => {
    setPage({...page, currentMessage: message, showDetalisMessage: true})
    if (message.read === false ) {
      markMessagesAsRead(message.id)
      notificationUpdate(globalDispatch, newNotification-1)
    }
  }

  const handleBackToAllMessage = () => {
    setPage({...page, currentMessageID: null, showDetalisMessage: false})
    fetchMessages(dispatch, {page: page.currentPage})
    checkNewMessages(globalDispatch)
  }

  const handleNexPage = () => {
    setPage({...page, currentPage: page.currentPage+1})
    fetchMessages(dispatch, {page: page.currentPage+1})
  }

  const handlePrevPage = () => {
    setPage({...page, currentPage: page.currentPage-1})
    fetchMessages(dispatch, {page: page.currentPage-1})
  }

  return (
    <Layout 
      loggedIn
      title={t('Messages.MainTitle')}
      mobileTopBar={ { centerTitle: t('Messages.MainTitle') } }
    >
      <Helmet bodyAttributes={{ class: 'messagesList-page' }}  />
      <main>
                <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <h1 className="main-title hide-mobile">
                {t('Messages.MainTitle')}
              </h1>
            </div>
          </div>

          <div className="card">
            
            {messages.loading ? 
              <div className="row mx-lg-3"><LoadingSpinner className="col-12 mt-4" /></div> : null}

            {!messages.loading && messages.success && !page.showDetalisMessage ? 
              <div>
                <MessagesList showMessageDetails={handleShowMessageDetails} messages={messages}/> 
                <div className="message-list__nav">
                  <button disabled={!messages.prevPage} 
                    onClick={()=>handlePrevPage()} type="button" 
                    className="bt bt-orange s-38">
                    <i className="icon-arrow-left"></i>
                    <span>{t('Messages.prev')}</span>
                  </button>
              
                  <button disabled={!messages.nextPage} 
                    onClick={()=>handleNexPage()} type="button" 
                    className="bt bt-orange s-38">
                    <span>{t('Messages.next')}</span>
                    <i className="icon-arrow-right"></i>
                  </button>
                </div>
              </div>
              : null }

            {!messages.loading && messages.error ? 
              <div className="row message-list__header">
                <div className="col-lg-12 text-center">
                  {t('Messages.emptyMessageList')}
                </div>
              </div> : null}

            {!messages.loading && page.showDetalisMessage ?         
              <MessageDetalis backToAllMessage ={handleBackToAllMessage} message={page.currentMessage}/> : null}

          </div>
        </div>
      </main>
    </Layout>
  )
}

Messages.propTypes = {
  message: PropTypes.object
}

export default Messages
